import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Breadcrumbs, Link as MuiLink, Typography } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

import { feedbackCall } from "../../redux/slice/feedback/feedback";

import "./ContactUs.scss";
import Header from "../../component/header/Header";
import Footer from "../../component/footer/Footer2";
import Spinner from "../../component/spinner/Spinner";
import location from "../../assets/images/location.svg";
import phone from "../../assets/images/phone.svg";
import mail from "../../assets/images/mail.svg";
// import mapimg from "../../assets/images/mapimage.svg";
import query from "../../assets/images/query.svg";
import { fetchMalls } from "../../redux/slice/malls/malls";
// import instagram from "../../assets/images/instagramm.svg";
// import facebook from "../../assets/images/facebookk.svg";
// import linkedin from "../../assets/images/linkedin.svg";

// Using mallsData from API for both desktop and mobile

function ContactUs() {
  const {
    // feedbackData,
    loading,
    // success
  } = useSelector((state) => state.feedback);
  const customerDetails = JSON.parse(
    localStorage.getItem("customerDetails") || "{}",
  );
  const { mallsData } = useSelector((state) => state.malls);

  const mobile = localStorage.getItem("mobile");
  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [addressError, setAddresssError] = useState("");
  const [checkError, setCheckError] = useState("");
  const [checked, setChecked] = useState(false);

  const getFullName = () => {
    if (customerDetails?.firstname && customerDetails?.lastname) {
      return customerDetails?.firstname + " " + customerDetails?.lastname;
    } else {
      return "";
    }
  };
  const [details, setDetails] = useState({
    fullName: getFullName(),
    mobile: mobile ? mobile : "",
    email: customerDetails?.email ? customerDetails?.email : "",
    state: "",
    city: "",
    address: sessionStorage.getItem("address") || "",
    query: sessionStorage.getItem("query") || "",
    subject: "Customer Service Center",
  });
  // console.log(details);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchMalls());
  }, []);

  const handleSubmit = async () => {
    // Regular expression for full name validation, email validation (simplified RFC 5322) and mobile number validation
    const nameRegex = /^[a-zA-Z\s'-]{1,50}$/;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const mobileRegex = /^91[1-9]\d{9}$/;
    let flag = false;

    if (!details.fullName || !nameRegex.test(details.fullName)) {
      setNameError(
        "Full name must be alphabetic (a-z, A-Z), may include hyphens, apostrophes, and spaces, and must be 0-50 characters long.",
      );
      flag = true;
    } else {
      setNameError("");
    }

    if (!details.email || !emailRegex.test(details.email)) {
      setEmailError("Please enter a valid email address.");
      flag = true;
    } else {
      setEmailError("");
    }

    if (!details.mobile || !mobileRegex.test(details.mobile)) {
      setMobileError("Mobile number must be exactly 10 digits.");
      flag = true;
    } else {
      setMobileError("");
    }

    if (!details.address) {
      setAddresssError("Please fill the Address field.");
      flag = true;
    } else {
      setAddresssError("");
    }
    if (!checked) {
      setCheckError("Please Agree to our Privacy & Policy.");
      flag = true;
    } else {
      setCheckError("");
    }
    if (flag) return;

    const data = {
      root: {
        email: [
          {
            // dlfmallsrewards@dlf.in
            // to: "dlfmallsrewards@dlf.in",
            to: "avenuerewards@dlf.in,promenaderewards@dlf.in,cyberhubrewards@dlf.in,delhimallsrewards@dlf.in,loyalty-moi@dlf.in,mallofindiarewards@dlf.in,mtprewards@dlf.in",
            cc: `${details.email ? details.email : ""}, dlfmallsrewards@dlf.in`,
            //   "cc": "ahaan.pandit@capillarytech.com",
            subject: details.subject,
            body: ` <!DOCTYPE html>\n<html>\n<head>\n  <meta charset="UTF-8">\n  <meta name="viewport" content="width=device-width, initial-scale=1.0">\n  <title>Contact US</title>\n  <style>\n    body {\n      font-family: Arial, sans-serif;\n      background-color: #f8f8f8;\n      margin: 0;\n      padding: 0;\n    }\n    table {\n      width: 100%;\n      border-collapse: collapse;\n      margin-top: 20px;\n    }\n    td {\n      padding: 5px 0;\n      vertical-align: top;\n    }\n    td.label {\n      font-weight: bold;\n      width: 120px;\n      color: #333333;\n    }\n    td.value {\n      color: #555555;\n    }\n  </style>\n</head>\n<body>\n  <div class="email-container">\n    <table>\n      <tr>\n        <td class="label">Full Name:</td>\n        <td class="value">${details.fullName}</td>\n      </tr>\n      <tr>\n        <td class="label">Mobile:</td>\n        <td class="value">${details.mobile}</td>\n      </tr>\n      <tr>\n        <td class="label">Address:</td>\n        <td class="value">${details.address}</td>\n      </tr>\n      <tr>\n        <td class="label">Email:</td>\n        <td class="value">${details.email}</td>\n      </tr>\n      <tr>\n        <td class="label">State:</td>\n        <td class="value">${details?.state}</td>\n      </tr>\n      <tr>\n        <td class="label">City:</td>\n        <td class="value">${details?.city}</td>\n      </tr>\n      <tr>\n        <td class="label">Query:</td>\n        <td class="value">${details?.query}</td>
          
    \n      </tr>\n    </table>\n  </div>\n</body>\n</html>\n`,
          },
        ],
      },
    };

    const result = await dispatch(feedbackCall({ data }));
    sessionStorage.removeItem("address");
    sessionStorage.removeItem("query");
    if (result?.payload?.status?.success) {
      toast.success("Feedback submitted successfully");
    } else {
      toast.error(result?.payload?.status?.message);
    }
    setDetails({
      fullName: getFullName(),
      mobile: mobile ? mobile : "",
      email: customerDetails?.email ? customerDetails?.email : "",
      state: "",
      city: "",
      address: "",
      query: "",
      subject: "",
    });
  };
  const breadcrumbsMobile = [
    <MuiLink
      underline="hover"
      key="1"
      color="inherit"
      onClick={() => navigate("/home")}
      sx={{
        fontSize: "12px",
        fontWeight: "300",
        lineHeight: "12px",
        color: "#A9A9A9",
      }}
    >
      Home
    </MuiLink>,
    <Typography
      key="3"
      sx={{
        fontSize: "12px",
        fontWeight: "700",
        lineHeight: "15px",
        color: "#ffffff",
      }}
    >
      Contact Us
    </Typography>,
  ];

  return (
    <>
      <div className="contact-us-page">
        <Header />
        <div className="headerbox container">
          <div className="container pt-5 in-mobile mobile_content">
            <Breadcrumbs
              separator={
                <NavigateNextIcon fontSize="small" sx={{ color: "#A9A9A9" }} />
              }
              aria-label="breadcrumb"
            >
              {breadcrumbsMobile}
            </Breadcrumbs>
          </div>
          <div className="headerleft">
            <p className="redtext">Contact Us</p>
            <p className="subtext">Need our help? Contact our Support team</p>
            <hr className="horiz"></hr>
            <div className="headtext">
              {/* <div className="location">
                <img src={location} alt="loaction icon" className="imgpad" />
                <p className="abovetext">
                  Office Address <br></br>
                  <span className="belowtext">
                    C-65/1, Okhla Industrial Area,Phase-2, New Delhi - (110020)
                    India
                  </span>
                </p>
              </div> */}
              {mallsData?.map((mall, index) => {
                return (
                  mall?.attributes?.phone_number && (
                    <div className="phone" key={index}>
                      <img src={phone} alt="phone icon" className="imgpad" />
                      <p className="abovetext">
                        {mall?.attributes?.mall_name} <br></br>
                        <span className="belowtext">
                          <a
                            href={`tel:${mall?.attributes?.phone_number}`}
                            style={{ textDecoration: "none", color: "inherit" }}
                          >
                            {mall?.attributes?.phone_number}
                          </a>
                        </span>
                      </p>
                    </div>
                  )
                );
              })}
              {/* <div className="mail">
                <img src={mail} alt="mail icon" className="imgpad" />
                <p className="abovetext">
                  Mail Address <br></br>
                  <span className="belowtext">dlfmallofindia.com</span>
                </p>
              </div> */}
            </div>
          </div>
        </div>
        <div className="rightpart container" style={{ textAlign: "center" }}>
          <div className="contactusbox">
            <div className="boxpadd">
              <p className="querytext">
                <img src={query} alt="quary icon" />
                Tell us your <span className="mobile_content">
                  business
                </span>{" "}
                query
              </p>
              <div className="form-check_1">
                <div className="inputboxfull">
                  <div
                    style={{ position: "relative" }}
                    className={nameError !== "" && "mb-37"}
                  >
                    <input
                      className="inputfield"
                      type="text"
                      id="fullname"
                      name="fullname"
                      placeholder=""
                      value={details?.fullName}
                      onChange={(e) => {
                        const nameRegex = /^[a-zA-Z\s'-]{1,50}$/;
                        if (nameRegex.test(e.target.value)) {
                          setNameError("");
                        }
                        setDetails({ ...details, fullName: e.target.value });
                      }}
                    />
                    <label htmlFor="fullname" className="filled-label">
                      Full Name <span className="required">*</span>
                    </label>
                    <span
                      style={{
                        color: "#DB4B41",
                        fontSize: "12px",
                        position: "absolute",
                        bottom: "-54px",
                      }}
                      className="mobile_content"
                    >
                      {nameError}
                    </span>
                  </div>

                  {/* <select
                    id="options"
                    name="Customer Service Center"
                    className="inputfield select"
                    value={details?.subject}
                    onChange={(e) => {
                      setDetails({ ...details, subject: e.target.value });
                    }}
                    style={{ backgroundColor: "#ffffff", paddingRight: "10px" }}
                  >
                    <option value="Customer Service Center">
                      Customer Service Center
                    </option>
                  </select> */}
                  {/* <div className="inputfield select" style={{ backgroundColor: "#ffffff", paddingRight: "10px" }}>
                  Customer Service Center
                  </div> */}
                </div>
                <span
                  style={{ color: "#DB4B41", fontSize: "12px" }}
                  className="desktop_content"
                >
                  {nameError}
                </span>
                <div className="inputbox">
                  <div
                    style={{
                      position: "relative",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <input
                      className="inputfield"
                      type="text"
                      id="mobile"
                      name="mobile"
                      placeholder=""
                      value={details?.mobile}
                      onChange={(e) => {
                        const mobileRegex = /^[1-9]\d{9}$/;
                        if (mobileRegex.test(e.target.value)) {
                          setMobileError("");
                        }
                        setDetails({ ...details, mobile: e.target.value });
                      }}
                    />
                    <label htmlFor="mobile" className="filled-label">
                      Mobile Number<span className="required">*</span>
                    </label>
                    <span
                      style={{
                        color: "#DB4B41",
                        fontSize: "12px",
                        position: "absolute",
                        bottom: "-37px",
                      }}
                      className="mobile-span"
                    >
                      {mobileError}
                    </span>
                  </div>

                  <div
                    style={{
                      position: "relative",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <input
                      className="inputfield"
                      type="text"
                      id="email"
                      name="email"
                      placeholder=""
                      value={details?.email}
                      onChange={(e) => {
                        const emailRegex =
                          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                        if (emailRegex.test(e.target.value)) {
                          setEmailError("");
                        }
                        setDetails({ ...details, email: e.target.value });
                      }}
                    />
                    <label htmlFor="email" className="filled-label">
                      Email ID<span className="required">*</span>
                    </label>
                    <span
                      style={{
                        color: "#DB4B41",
                        fontSize: "12px",
                        position: "absolute",
                        bottom: "-33px",
                      }}
                      className="inMob"
                    >
                      {emailError}
                    </span>
                  </div>
                </div>
                {/* <div className="inputbox">
                  <div>
                    <select
                      id="options"
                      name="State"
                      className="inputfield"
                      value={details?.state}
                      onChange={(e) => {
                        setDetails({ ...details, state: e.target.value });
                      }}
                      style={{ backgroundColor: "#ffffff" }}
                    >
                      <option value="">State</option>
                      <option value="State1">State 1</option>
                      <option value="State2">State 2</option>
                    </select>
                  </div>
                  <div style={{ position: "relative" }}>
                    <input
                      className="inputfield"
                      type="text"
                      id="city"
                      name="city"
                      placeholder=""
                      value={details?.city}
                      onChange={(e) => {
                        setDetails({ ...details, city: e.target.value });
                      }}
                    />
                    <label htmlFor="city" className="filled-label">
                      City
                    </label>
                  </div>
                </div> */}
                <div className="inputboxfull">
                  <div
                    style={{
                      position: "relative",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <input
                      className="inputfield"
                      type="text"
                      id="address"
                      name="address"
                      placeholder=""
                      value={details?.address}
                      onChange={(e) => {
                        setAddresssError("");
                        sessionStorage.setItem("address", e.target.value);
                        setDetails({ ...details, address: e.target.value });
                      }}
                    />
                    <label htmlFor="address" className="filled-label">
                      Address<span className="required">*</span>
                    </label>
                    <span
                      style={{
                        color: "#DB4B41",
                        fontSize: "12px",
                        position: "absolute",
                        bottom: "-18px",
                      }}
                    >
                      {addressError}
                    </span>
                  </div>
                </div>
                <div className="inputboxfull">
                  <div>
                    <textarea
                      className="textbox"
                      id="query"
                      name="query"
                      placeholder="Write your query here"
                      rows="5"
                      value={details?.query}
                      onChange={(e) => {
                        sessionStorage.setItem("query", e.target.value);
                        setDetails({ ...details, query: e.target.value });
                      }}
                    ></textarea>
                  </div>
                </div>
                <label className="form-check-label" htmlFor="flexCheckDefault">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    value={checked}
                    id="flexCheckDefault"
                    onChange={() => setChecked((prev) => !prev)}
                  />
                  By clicking the "Submit Details" button above, you agree to
                  our
                  <Link to="/privacy-policy" className="privacylink">
                    {" "}
                    Privacy & Policy
                  </Link>
                </label>
                <span
                  style={{
                    color: "#DB4B41",
                    fontSize: "12px",
                  }}
                  className="desktop_content"
                >
                  {checkError}
                </span>
                <button
                  onClick={() => {
                    handleSubmit();
                  }}
                  style={{ display: "flex", margin: "16px auto" }}
                >
                  Submit Details {loading ? <Spinner /> : null}
                </button>
              </div>
            </div>
            {/* <div className="redbox">
              <div className="redboxcontent">
                <div>
                  <p>Reach us on Social platforms</p>
                </div>
                <div className="socialicons">
                  <img src={instagram} />
                  <img src={facebook} />
                  <img src={linkedin} />                  
                </div>
              </div>
            </div> */}
          </div>
        </div>
        <div className="formbelow-mobile">
          <label className="form-check-label" htmlFor="flexCheckDefault1">
            <input
              className="form-check-input"
              type="checkbox"
              value={checked}
              id="flexCheckDefault1"
              onChange={() => setChecked((prev) => !prev)}
            />
            By clicking the "Submit Details" button above, you agree to our
            <Link to="/privacy-policy" className="privacylink">
              {" "}
              Privacy & Policy
            </Link>
          </label>
          <span
            style={{
              color: "#DB4B41",
              fontSize: "12px",
            }}
            className="mobile_content"
          >
            {checkError}
          </span>
          <button
            onClick={() => {
              handleSubmit();
            }}
            style={{ display: "flex", justifyContent: "center" }}
          >
            Submit Details {loading ? <Spinner /> : null}
          </button>

          <div className="whiteboxx">
            <div className="headtext">
              {/* <div className="location">
                <img src={location} alt="location icon" className="imgpad" />
                <p className="abovetext">
                  Office Address <br></br>
                  <span className="belowtext">
                    C-65/1, Okhla Industrial Area,Phase-2, New Delhi - (110020)
                    India
                  </span>
                </p>
              </div> */}
              <img src={phone} alt="phone icon" className="imgpad" />
              {mallsData?.map((mall, index) => {
                return (
                  mall?.attributes?.phone_number && (
                    <div className="phone" key={index}>
                      <p className="abovetext">
                        {mall?.attributes?.mall_name} <br></br>
                        <span className="belowtext">
                          <a
                            href={`tel:${mall?.attributes?.phone_number}`}
                            style={{ textDecoration: "none", color: "inherit" }}
                          >
                            {mall?.attributes?.phone_number}
                          </a>
                        </span>
                      </p>
                    </div>
                  )
                );
              })}
              {/* <div className="mail">
                <img src={mail} alt="mail icon" className="imgpad" />
                <p className="abovetext">
                  Mail Address <br></br>
                  <span className="belowtext">dlfmallofindia.com</span>
                </p>
              </div> */}
            </div>
          </div>
        </div>

        <div style={{ marginTop: "10px" }}>
          <Footer selected="home" />
        </div>
      </div>
    </>
  );
}

export default ContactUs;
